import { useEffect } from 'react'
import { CircleCheck, CircleDashed } from 'lucide-react'
import { ActiveFactoringProviderLabels } from '@numeo/types-core'
import { useFactoringStatusStore } from '@/hooks/factoringStatusStore'

/**
 * The factor the company's invoices go to, in the chat's top bar, as the Invoices page shows its connection: the same store the
 * selection bar reads, so the chip and the send action ("Submit to factoring" or "Send by email") always agree.
 */
export const FactoringStatusChip = () => {
    const provider = useFactoringStatusStore((state) => state.activeProviders.main)
    const loaded = useFactoringStatusStore((state) => state.hasLoaded)
    const refresh = useFactoringStatusStore((state) => state.refresh)
    useEffect(() => {
        if (!loaded) void refresh()
    }, [loaded, refresh])

    if (!loaded) return null
    return provider ? (
        <span
            className="inline-flex items-center gap-1.5 rounded-full bg-success-soft px-2.5 py-1 text-xs font-medium text-success-soft-foreground"
            title="Invoices are submitted to this factor"
        >
            <CircleCheck className="h-3.5 w-3.5" aria-hidden />
            {ActiveFactoringProviderLabels[provider]} connected
        </span>
    ) : (
        <span
            className="inline-flex items-center gap-1.5 rounded-full bg-default px-2.5 py-1 text-xs font-medium text-foreground-muted"
            title="Invoices are sent to brokers by email"
        >
            <CircleDashed className="h-3.5 w-3.5" aria-hidden />
            Factoring not connected
        </span>
    )
}
